// Persiste el tenantId del deep link `?join=...` a través del flujo de auth
// (que redirige a /login y pierde la querystring).

const KEY = "fideliza:pendingJoin";

export function rememberPendingJoin(tenantId: string | null): void {
  if (!tenantId) return;
  try {
    sessionStorage.setItem(KEY, tenantId);
  } catch {
    /* sessionStorage no disponible (incognito agresivo / iframe) */
  }
}

export function readPendingJoin(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearPendingJoin(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

// Capturar y guardar el ?join=... apenas carga la app, antes de cualquier redirect.
export function capturePendingJoinFromUrl(): void {
  try {
    const url = new URL(window.location.href);
    const join = url.searchParams.get("join");
    rememberPendingJoin(join);
    // Tambien capturamos ?ref= si viene (codigo de embajador) para autoactivarlo
    const ref = url.searchParams.get("ref");
    if (ref) {
      try {
        sessionStorage.setItem("fideliza:pendingRef", ref.toUpperCase());
      } catch {
        /* ignore */
      }
    }
  } catch {
    /* ignore */
  }
}

export function readPendingRef(): string | null {
  try {
    return sessionStorage.getItem("fideliza:pendingRef");
  } catch {
    return null;
  }
}

export function clearPendingRef(): void {
  try {
    sessionStorage.removeItem("fideliza:pendingRef");
  } catch {
    /* ignore */
  }
}
